import { Pipe, PipeTransform } from '@angular/core';
import { BcmService } from '@modules/bcm/bcm.service';
import { Tenant } from '@shared/models/tenant';
import { InvoicePosition } from '@shared/models/invoice-position';
import { ProductService } from '@modules/bcm/products/product/product.service';
import { getTaxRateValue } from '@core/functions/get-tax-rate-value';

@Pipe({
    name: 'bcmDynamicNetToGrossPrice',
    standalone: false
})
export class DynamicNetToGrossPricePipe implements PipeTransform {

    tenant: Tenant;

    constructor(private bcmService: BcmService,
                private productService: ProductService) {
        this.bcmService.selectedTenant$.subscribe(tenant => this.tenant = tenant);
    }

    transform(position: InvoicePosition, total = false): number {
        if (this.tenant.managePricesInNet) {
            const texRateValue = getTaxRateValue(position);
            if (total) {
                return this.productService.getGrossPrice(position.totalPrice, texRateValue);
            }
            return this.productService.getGrossPrice(position.price, texRateValue);
        }

        return total ? position.totalPrice : position.price;
    }
}
